import * as React from 'react'

const SvgDraggableIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 3.125h2.5v2.5h-2.5v-2.5zm5 0h2.5v2.5h-2.5v-2.5zm-5 5.625h2.5v2.5h-2.5v-2.5zm5 0h2.5v2.5h-2.5v-2.5zm-5 5.625h2.5v2.5h-2.5v-2.5zm5 0h2.5v2.5h-2.5v-2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgDraggableIcon
